var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mr-2",attrs:{"x-small":"","color":_vm.chipsColor,"text-color":_vm.textColor}},[_vm._v(" "+_vm._s(_vm.formattedChipText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }